const monitoringTranslation = {
  mode: 'en',
  menu: 'Device Monitoring',

  totalUpload: 'Total Upload',
  currentStatus: 'Status',
  videoDevice: 'CaptureBD',
  videoDeviceStatus: 'Video Signal',
  activity: 'Last Activity',
  scan: 'Last Scan',

  start: 'Program Start',
  nosess: 'Standby',
  session: 'Motion Detecting',
  recording: 'Recording',
  paused: 'Paused',
  exit: 'Program Exit',

  // v3 Status
  created: 'Booting',
  initializing: 'Initializing',
  standby: 'Standby',
  motion_detection: 'Motion Detecting',
  warn: 'Warning',
  notice: 'Notice',

  lsHdml: 'IsHdml',
  lsEasyCap: 'EasyCap',
  yuh01: 'YUH-01',
  gameDockUltra: 'GameDock Ultra',
  yux13: 'YUX13',
  asus: 'ASUS capturecard',
  unknown: 'Unknown',

  hdmlYuyv422: 'HDMI/YUYV422',
  hdmlMjpeg: 'HDMI/MJPEG',
  analog: 'Analog',
  dark: 'Dark',
  error: 'Error',

  pingAll: 'Ping all devices',
  sendRemoteCommand: 'Send command',
  restartApp: 'Restart Program',
  stopRecording: 'Stop Recording',
  restartAppV3: 'Restart V3 Program',
  rebootDeviceV3: 'Reboot V3 Device',
  shutdownDeviceV3: 'Shutdown V3 Device',
  rollbackDeviceV3: 'Rollback V3 Device',
  agent: 'Remote Access',
  agentCommandCenter: 'Agent Command Center',
  sshControl: 'SSH Control',
  copyCommand: 'Copy SSH Command',
  port: 'Port',

  enterBarcode: 'Enter Barcode',
  barcodePlaceholder: 'Please enter the barcode to use for testing.',

  testAutoRecording: 'Auto Recording Test',
  testAutoRecordingResult: 'Auto Recording Test Result',
  testingAutoRecording: 'Testing Auto Recording...',
  testStep: 'Test Step',
  testStepStatus: 'Result',
  elapsedTime: 'Elapsed Time',
  testDetails: 'Test Details',
  viewTestCaptureDetails: 'View Test Capture Time',
  testCaptureDetails: 'Test Capture Time',
  captureStartTime: 'Capture Start Time',
  dbCreatedAt: 'Server Upload Time',

  online: 'Online',
  recordStatus: 'Recording',
  uploadStatus: 'Uploading',
  sshConnected: 'SSH Connected',

  logInquiry: 'Check Log',
  syncLog: 'Update Log',
  refreshLog: 'Refresh Log',
  requestLog: 'Request Log',
  ping: 'Ping',
  remainingTime: 'You can try again in {{seconds}} seconds',
  showPreviousImage:
    '{{seconds}} seconds remaining until new screenshot request. Showing previous image.',
  more: 'More',

  deviceLogExplorer: 'Log Explorer',
  selectLogDate: 'Select Log Date',
  totalLog: 'Total Log',
  logByBarcode: 'Log by Barcode',
  alertHistory: 'Alert History',
  barcode: 'Barcode',
  scannedAt: 'Scanned At',
  fileId: 'File ID',
  scanInfo: 'Scan Info',
  detail: 'Detail',
  time: 'Time',
  text: 'Text',
  copyBarcodeTooltip: 'Copy barcode',
  copyBarcodeSuccess: 'Barcode copied',
  copyBarcodeFail: 'Failed to copy barcode',
  motionInfo: 'Motion Info',
  recordInfo: 'Recording Info',
  uploadInfo: 'Upload Info',
  segment: 'Segment',
  startTime: 'Start at',
  endTime: 'End at',
  duration: 'Duration',
  success: 'Success',
  fail: 'Failed',
  recordingCheck: 'Check recording',
  motionCheck: 'Check motion',
  recordingsDownload: 'Download recording',
  download: 'Download',
  alertTime: 'Detected At',
  alertSeverityLabel: 'Severity',
  alertSeverity: {
    info: 'Info',
    warning: 'Warning',
    error: 'Error',
    critical: 'Critical',
  },
  alertCode: 'Code',
  alertMessage: 'Message',
  alertStatusSummary: 'Status Summary',
  alertSlackStatus: 'Slack Status',
  alertSlackLink: 'Slack Link',
  alertOpenSlack: 'Open',
  alertSlackStatusValue: {
    PENDING: 'Pending',
    SKIPPED: 'Skipped',
    THRESHOLD_SKIPPED: 'Below Threshold',
    ROOT_SENT: 'Channel Message',
    THREAD_SENT: 'Thread',
    FAILED: 'Failed',
  },
  alertNoData: 'No alerts recorded.',

  failedUploadRecordingDownload: 'Failed Upload Recording or motion Download',
  downloadTitle: 'Download Confirmation',
  customCropTitle: 'Crop Settings',
  recordingScreenSettings: 'Recording Screen Settings',
  remoteCommandTitle: 'Remote Setting',
  refreshScreenshot: 'Refresh Screenshot',
  nextScreenshotIn: 'Next screenshot request in {{seconds}}s.',
  preset: 'Preset',
  current: 'Current',
  selectResolution: 'Select Resolution',
  applyResolution: 'Apply Resolution',
  applyCrop: 'Apply Crop',
  noScreenshotData: 'No screenshot data available',
  failedToLoadScreenshot: 'Failed to load screenshot',
  loadingScreenshot: 'Loading screenshot...',
  noScreenshotAvailable: 'Unable to display the screen image. Please refresh or contact support.',

  name: 'Device',
  open: 'Open',
  close: 'Close',
  version: 'Version',
  update: 'Update',
  disconnect: 'Disconnect',
  connect: 'Connect',
  versionPlaceholder: 'Select Version',
  silentUpdate: 'Silent Update',
  silentUpdateDescription: 'Available from Agent 2.0.0 version',

  remoteScan: 'Remote recording',
  resolution: 'Resolution',
  resolutionSettings: 'Resolution Settings',
  crop: 'Screen Crop',
  cropSettings: 'Crop Settings',
  resetCrop: 'Reset Crop',
  customCrop: 'Custom Screen Crop',
  category: 'Command',
  value: 'Value',

  selectHospitalMessage: 'Please select an account.',
  searchDevicePlaceholder: 'Find a hospital by device name',
  unassignedRoomGroup: 'No room assigned',
  inactiveDeviceGroup: 'Inactive devices',
  cropMessage: 'Change the screen crop?',
  customCropMessage: 'Change the screen crop?',
  customCropError: 'Failed to set custom crop. Please check and try again.',
  syncLogMessage: 'Update the logs?',
  sendPingMessage: 'Send a ping?',
  stopRecordingMessage: 'Stop recording?',
  restartAppMessage: 'Restart the program?',
  resolutionMessage: 'Change resolution?',
  remoteScanMessage: 'Proceed a remote scan?',
  showScreenshotMessage: 'View screenshot?',
  liveMessage: 'It will update instantly.',
  noLogMessage: 'No logs.',
  noEquipmentMessage: 'No devices found.',
  noVideoMessage: 'Error: Download failed. No video exists.',
  failDownloadMessage: 'Error: Download failed. Please try again.',
  failScreenshotMessage: 'Error: Failed to request a screenshot. Showing last saved screenshot.',
  noLargeScreenshotAvailable: 'No large screenshot available. Please try again later.',
  logRequestSent: 'Log Request Sent',
  logRequestMessage:
    'Log transfer has been requested.\nIf the device network is normal, it will send the log to the server.\nPlease click the "Refresh Log" button after 10 seconds to 1 minute.',
  commandNotAvailable: 'Command send feature is not available.',
  downloadStartMessage: 'Click to download',
  agentUpdateMessage: 'Agent update requested.',
  mommyBoxUpdateMessage1: 'Device',
  mommyBoxUpdateMessage2: 'Update requested.',
  sshOrderMessage: 'Connection requested.',
  sshOrderCloseMessage: 'Disconnection requested.',
  rebootDeviceMessage: 'proceed to reboot the device?',
  shutdownDeviceMessage: 'proceed to shutdown the device?',
  rollbackDeviceMessage: 'proceed to rollback before version?',

  // Remote control modal
  textSend: 'Text Send',
  textSendPlaceholder: 'Enter barcode or command',
  send: 'Send',
  recordingControl: 'Recording Control',
  recordingResume: 'Resume Recording',
  recordingPause: 'Pause',
  recordingStop: 'Stop Recording',
  recordingCancel: 'Cancel Recording',
  screenCapture: 'Screen Capture',
  systemControl: 'System Control',
  sendPing: 'Send Ping',
  appRestart: 'App Restart',
  enterTextMessage: 'Please enter text',
  commandSentMessage: 'Command has been sent',
  selectDeviceMessage: 'Please select a device',
  remoteControl: 'Remote Control',
  recordingStartStop: 'Start/Stop Recording',
  recordingResumePause: 'Resume/Pause Recording',

  // Log parser related
  logTotalLines: 'Total {{count}} lines',
  logParsedLines: 'Parsed: {{count}} lines',
  logUnparsedLines: 'Failed to parse: {{count}} lines',

  // Log loading stages
  logRequesting: 'Requesting logs...',
  logDownloading: 'Downloading logs...',
  logAnalyzing: 'Analyzing logs...',

  // Log search related
  searchLog: 'Search Log',
  searchPlaceholder: 'Enter text to search... (5+ characters, use button for force search)',
  searchResults: 'Search results: {{current}}/{{total}}',
  noSearchResults: 'No search results found',
  nextResult: 'Next result',
  previousResult: 'Previous result',

  // RemoteOps additions
  sshOpenRequested: 'SSH open requested',
  sshCloseRequested: 'SSH close requested',
  sshReconnectRequested: 'SSH reconnect requested',
  failedList: 'Failed to list directory',
  failedDownload: 'Download failed',
  failedDelete: 'Delete failed',
  failedDisk: 'Failed to get disk usage',
  cleanDone: 'Clean completed',
  cleanFailed: 'Clean failed',
  failedPm2: 'Failed to get processes',
  restarted: 'Restarted',
  restartFailed: 'Restart failed',
  applied: 'Applied',
  applyFailed: 'Apply failed',
  failedVolume: 'Failed to get volume',
  failedSetVolume: 'Failed to set volume',
  failedUsb: 'Failed to get USB status',
  patchBoxRequested: 'Patch box requested',
  patchAgentRequested: 'Patch agent requested',
  patchFailed: 'Patch failed',
  factoryResetRequested: 'Factory reset requested',
  factoryResetFailed: 'Factory reset failed',
  reconnect: 'Reconnect',
  used: 'Used',
  list: 'List',
  logs: 'Logs',
  trash: 'Trash',
  cache: 'Cache',
  cleanSelected: 'Clean Selected',
  type: 'Type',
  size: 'Size',
  modified: 'Modified',
  actions: 'Actions',
  select: 'Select',
  autoRefreshIn: 'Auto refresh in {{seconds}}s',
  refreshNow: 'Refresh Now',
  disk: 'Disk',
  path: 'Path',
  usbDevices: 'USB Devices',
  deviceType: {
    LED: 'LED',
    SCANNER: 'Scanner',
    FOOTSWITCH: 'Foot Switch',
    REMOTESWITCH: 'Remote',
    CAPTUREBOARD: 'Capture Board',
  },
  otherDevices: 'Others',
  connected: 'Connected',
  disconnected: 'Disconnected',
  processes: 'Processes',
  uptime: 'Uptime',
  memory: 'Memory',
  refreshDevices: 'Refresh Devices',
  refreshVolume: 'Refresh Volume',
  volume: 'Volume',
  unmute: 'Unmute',
  mute: 'Mute',
  apply: 'Apply',
  patchBox: 'Patch Box',
  versionOptional: 'version (optional)',
  patch: 'Patch',
  patchAgent: 'Patch Agent',
  deleteDbFiles: 'Delete DB Files',
  addPath: 'Add Path',
  noPaths: 'No paths',
  dbDeleted: 'DB files deleted',
  factoryReset: 'Factory Reset',
  runFactoryReset: 'Run Factory Reset',
  searchFiles: 'Search files',
  notConnected: 'SSH is not connected. Please connect first.',
  sshDisconnected: 'SSH connection lost. Please reconnect.',
  autoDisconnectTitle: 'Idle connection',
  autoDisconnectContent: 'No activity for 1 minute. Disconnect SSH?',
  connecting: 'Waiting for connection response...',
  connectFailed: 'SSH is not connected. Please connect first.',
  quickPaths: 'Quick Paths',
  basePath: 'Home',
  videos: 'Videos',
  captures: 'Captures',
  db: 'DB',
  trashCan: 'Trash Can',
  deleteFileConfirmTitle: 'Delete File',
  deleteFileConfirmContent:
    'Are you sure you want to delete this file? This action cannot be undone.',

  // SSH compact banner statuses
  sshStatusConnected: 'Connected',
  sshStatusConnecting: 'Connecting',
  sshStatusDisconnected: 'Disconnected',
  copySshCommand: 'Copy Command',
  sshCopyTooltip: 'Copy terminal command',
  clearItem: 'Clear',
  clearItemConfirmTitle: 'Clear Folder',
  clearItemConfirmContent: 'Delete ALL contents of {{label}} folder? This cannot be undone.',
  refresh: 'Refresh',
  refreshAll: 'Refresh all opened folders',
  refreshFailed: 'Refresh failed',
  refreshing: 'Refreshing...',
  loading: 'Loading...',
  // Overview loading text shown right after opening Remote Tools
  loadingOverview: 'Loading...',
  autoRefreshPaused: 'Auto-refresh paused due to inactivity',
  autoRefreshPausedText: 'Auto-refresh paused',
  resumeAutoRefresh: 'Resume Auto-refresh',
  folderUsage: 'Folder Usage',
  temperature: 'Temperature',

  // System Information Card Titles
  systemOverview: 'System Overview',
  hardware: 'Hardware',
  software: 'Software',
  volumeControl: 'Volume Control',
  networkInterfaces: 'Network Interfaces',
  audioRecording: 'Audio Recording',
  audioPlayback: 'Audio Playback',
  systemInfoRefreshed: 'System information refreshed',
  systemInfoRefreshFailed: 'Failed to refresh system information',

  // Remote Tools and Remote Ops related
  remoteTools: 'Remote Tools',
  overview: 'Overview',
  files: 'File Explorer',
  system: 'System',
  copyFailed: 'Copy failed',
  noVolumeInfo: 'No volume information available',
  noRecordingDevices: 'No recording devices',
  noPlaybackDevices: 'No playback devices',
  noUsbDevicesDetected: 'No USB devices detected',
  active: 'ACTIVE',
  inactive: 'INACTIVE',

  // Clean items related
  cleanSuccess: 'Clean Success',
  cleanSuccessDetails: 'Selected items have been successfully cleaned.',
  deletedFiles: 'Deleted Files',
  freedSpace: 'Freed Space',
  totalFiles: 'Total Files',
  totalSize: 'Total Size',
  showDetails: 'Show Details',
  hideDetails: 'Hide Details',
  fileName: 'File Name',
  fileSize: 'File Size',
  fileType: 'Type',
  directory: 'Directory',
  file: 'File',
  video: 'Video',
  capture: 'Capture',
  other: 'Other',

  // Download deletion related
  deleteDownload: 'Delete Download',
  deleteDownloadConfirm: 'Delete download?',
  deleteDownloadConfirmDescription: 'This action cannot be undone.',
  downloadDeleted: 'Download deleted',
  downloadDeleteFailed: 'Failed to delete download:',

  // SSH connection related messages
  connectionRequired: 'SSH connection is required to use remote tools.',
  selectHostAndConnect: 'Select SSH host and click the connect button.',
  loadingDeviceInfo: 'Loading device information...',

  // File download related
  downloadProgress: 'Downloading',
  downloadReady: 'File download completed.',
  unknownSize: 'Unknown',
  fileNotFound: 'File information not found.',
  unknownFileSize: 'Unable to determine file size.',
  chunkSizeMismatch: 'Chunk size mismatch. Please try again.',
  largeFileDownloadConfirmTitle: 'Large File Download',
  largeFileDownloadConfirmContent:
    'File size is {{size}}, exceeding 5MB.\nWould you like to start download via Download Center?\n\nYou can check the progress in Download Center.',
  downloadCenterNotice: 'Starting download via Download Center.',
  sshOrderError: 'An error occurred while requesting SSH connection.',
};

export default monitoringTranslation;
